import { NavLink } from "react-router-dom";

export default function SaleProducts({ id, title, description, img, col }) {
  return (
    <NavLink
      to={`/product/${id}`}
      className={`col-lg-${col} col-md-6 col-12`}
    >
      <div className="m-1 border rounded p-3 h-100 d-flex flex-column justify-content-between">
        <div>
          <p className="text-truncate" style={{ color: "gray" }}>
            {title}
          </p>
          <p className="text-truncate text-black">{description}</p>
        </div>
        <div className="px-5 py-4 position-relative">
          <div
            className="w-100"
            style={{
              backgroundImage: `url('${img}')`,
              backgroundPosition: "center",
              backgroundSize: "cover",
              height: "170px",
              width: "100%",
            }}
          />
        </div>
      </div>
    </NavLink>
  );
}
